module.exports = __webpack_public_path__ + "static/media/icon-sq-24-star-filled.f5a95261.svg";